import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { SUBSCRIPTIONS_APIS } from "../constants/MySubscriptions.constants";

export const useSubscriptionPlans = () =>
  useCustomQuery({
    url: SUBSCRIPTIONS_APIS.SUBSCRIPTIONS_PLANS,
    queryKey: [SUBSCRIPTIONS_APIS.SUBSCRIPTIONS_PLANS],
  });
